import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { skeletonLineDriverFactory } from './SkeletonLine.driver';
import { SkeletonLine } from './index';

describe('SkeletonLine', () => {
  const createDriver = createRendererWithUniDriver(skeletonLineDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<SkeletonLine />);
    expect(await driver.exists()).toBe(true);
  });
});
